<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="390"
    >
      <template v-slot:activator="{  }">
        <v-btn
          block
          :color="config.BGColor"
          :disabled="loading"
          :style="{ color: config.Color }"
          @click="onShowForm"
        >
          {{$t('dtouch.dishOrders.payOrder', locale)}}
        </v-btn>
      </template>
      <v-card >
        <iframe v-show="payStep" id="targetIframe" style="width:100%;height:560px;" />
        <div
          v-if="!payStep"
        >
        <v-card-title class="text-h5" style="padding-bottom: 20px">
          {{$t('dtouch.dishOrders.formConfirm.title', locale)}}
        </v-card-title>
        <v-card-text
        >
          <v-text-field
            :label="'Email'.concat(' (*)')"
            outlined
            v-model="email"
            hide-details
            style="width: 100%"
          />
          <small 
            v-if="showRequired && (!email || email.length ===0)"
            style="color: red;float: right;"
          >
            * {{$t('dtouch.dishOrders.formConfirm.required', locale).toLowerCase()}}
          </small>
        </v-card-text>
        <v-card-text
          v-for="(item, index) of formConfirm.filter(x => x.name !== 'email')"
          :key="index"
        >
          <v-text-field
            v-if="item.type === 'text'"
            :label="$t(`dtouch.dishOrders.formConfirm.${item.name}`, locale).concat(' (*)')"
            outlined
            v-model="item.value"
            hide-details
            style="width: 100%"
          />
          <small 
            v-if="showRequired && (!item.value || item.value.length ===0)"
            style="color: red;float: right;"
          >
            * {{$t('dtouch.dishOrders.formConfirm.required', locale).toLowerCase()}}
          </small>
        </v-card-text>
        <v-card-actions style="width:100%; padding-bottom: 10px;">
          <v-layout
            wrap
            style="width: 100%;margin-top: -20px;"
          >
          <v-flex 
            xs12
            style="padding: 10px;"
          >
            <!--v-card style="background-color: #CCCCCC;">
              <v-card-title class="text-h5" style="padding-bottom: 20px">
                {{$t('dtouch.dishOrders.formConfirm.card.title', locale)}}
              </v-card-title>
              <v-card-text>
                <v-text-field
                  :label="$t(`dtouch.dishOrders.formConfirm.card.name`, locale).concat(' (*)')"
                  outlined
                  v-model="card.name"
                  hide-details
                  style="width: 100%"
                />
                <small 
                  v-if="showRequired && (!card.name || card.name.length ===0)"
                  style="color: red;float: right;"
                >
                  * {{$t('dtouch.dishOrders.formConfirm.required', locale).toLowerCase()}}
                </small>
              </v-card-text>
              <v-card-text>
                <v-text-field
                  :label="$t(`dtouch.dishOrders.formConfirm.card.number`, locale).concat(' (*)')"
                  outlined
                  v-model="card.number"
                  hide-details
                  style="width: 100%"
                />
                <small 
                  v-if="showRequired && (!card.number || card.number.length ===0)"
                  style="color: red;float: right;"
                >
                  * {{$t('dtouch.dishOrders.formConfirm.required', locale).toLowerCase()}}
                </small>
              </v-card-text>
              <v-card-text>
                <v-text-field
                  :label="$t(`dtouch.dishOrders.formConfirm.card.expiryMonth`, locale).concat(' (*)')"
                  outlined
                  v-model="card.expiry_month"
                  hide-details
                  style="width: 100%"
                />
                <small 
                  v-if="showRequired && (!card.expiry_month || card.expiry_month.length ===0)"
                  style="color: red;float: right;"
                >
                  * {{$t('dtouch.dishOrders.formConfirm.required', locale).toLowerCase()}}
                </small>
              </v-card-text>
              <v-card-text>
                <v-text-field
                  :label="$t(`dtouch.dishOrders.formConfirm.card.expiryYear`, locale).concat(' (*)')"
                  outlined
                  v-model="card.expiry_year"
                  hide-details
                  style="width: 100%"
                />
                <small 
                  v-if="showRequired && (!card.expiry_year || card.expiry_year.length ===0)"
                  style="color: red;float: right;"
                >
                  * {{$t('dtouch.dishOrders.formConfirm.required', locale).toLowerCase()}}
                </small>
              </v-card-text>
              <v-card-text>
                <v-text-field
                  :label="$t(`dtouch.dishOrders.formConfirm.card.cvv`, locale).concat(' (*)')"
                  outlined
                  v-model="card.cvv"
                  hide-details
                  style="width: 100%"
                />
                <small 
                  v-if="showRequired && (!card.cvv || card.cvv.length ===0)"
                  style="color: red;float: right;"
                >
                  * {{$t('dtouch.dishOrders.formConfirm.required', locale).toLowerCase()}}
                </small>
              </v-card-text>

            </v-card-->
          </v-flex>
          <v-flex
            xs1
            v-if="sTerms ? true : false"
            style="padding-left:10px;"
          >
            <v-checkbox
              v-model="isAcceptTerms"
            />
          </v-flex>
          <v-flex
            xs11
            v-if="sTerms ? true : false"
            style="padding-top: 20px;padding-left: 10px;"
          >
            <accept-terms
              :termsLink="termsLink"
              :sTerms="sTerms"
              :locale="locale"
              :onChange="handleChangeAcceptTerms"
            />
          </v-flex>
          <v-flex
            xs6
            style="padding: 10px 10px 10px 10px;"
          >
            <v-btn
              @click="onCancel"
              block
            >
              {{ $t('common.cancel', locale) }}
            </v-btn>
          </v-flex>
          <v-flex
            xs6
            style="padding: 10px 10px 10px 10px;"
          >
            <v-btn
              block
              :color="config.BGColor"
              :style="{ color: config.Color }"
              @click="handleConfirm"
              :disabled="!isAcceptTerms && sTerms ? true : false"
            >
              {{$t('dtouch.dishOrders.payOrder', locale)}}
            </v-btn>
          </v-flex>
          </v-layout>
        </v-card-actions>
      </div>
      </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios'
  import utils from '@/services/utils'
  import AcceptTerms from '../AcceptTerms'
  export default {
    name: 'Globalpayment',
    components: {
      AcceptTerms,
    },
    props: {
      orderID: {
        type: String,
        required: true,
      },
      config: {
        type: Object,
        default: null,
      },
      formConfirm: {
        type: Array,
        required: true,
      },
      locale: {
        type: String,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      onShowForm: {
        type: Function,
        required: true,
      },
      onCancel: {
        type: Function,
        required: true,
      },
      onPay: {
        type: Function,
        required: true,
      },
      showForm: {
        type: Boolean,
        default: false,
      },
      termsLink: {
        type: String,
        default: null,
      },
      terms: {
        type: Object,
        default: null,
      },
    },
    data: () => ({
      dialog: false,
      payStep: false,
      formItems: null,
      showRequired: false,
      sTerms: null,
      isAcceptTerms: false,
      email: process.env.VUE_APP_ENV === 'development' ? 'test@descubregroup.com' :null,
      card: process.env.VUE_APP_ENV === 'development' ? {
        "name": 'Test Descubre Group',
        "number": "4242424242424242",
        "expiry_month": "12",
        "expiry_year": "30",
        "cvv":"123",
        } : {}
    }),
    watch: {
      showForm () {
        this.dialog = this.showForm
      },
      terms () {
        this.prepareTerms()
      },
      locale () {
        this.prepareTerms()
      },
    },
    mounted () {
      this.dialog = this.showForm
      this.prepareTerms()
    },
    methods: {
      async preparePay () {
        try {
          const data = {
            isAcceptTerms: this.isAcceptTerms,
            paymentEmail: this.email,
          formConfirm: JSON.parse(JSON.stringify(this.formConfirm)).filter(x => x.name !== 'email')
          }
          data.formConfirm.push({ name: 'email', type: 'text', value: this.email})
          //const url = `https://www.dtouch.es/assets/addon-payments/examples/hpp/proxy-request.php?slug=process-a-payment`
          const url = `${process.env.VUE_APP_ENV === 'production' ? 'https://www.dtouch.es' : 'http://dtouch.local:3400' }/public/dish-orders/${this.orderID}/prepare-stripe-payments`
          const body = await new Promise((resolve, reject) => axios.post(url, data)
            .then(response => {
              resolve(response.data)
            })
            .catch(error => {
              alert('error')
            }))
        window.location.href = body
        /*
        document.getElementById('targetIframe').src = body
        /*
          //RealexHpp.setHppUrl('https://hpp.sandbox.addonpayments.com/pay')
          RealexHpp.setHppUrl('https://hpp.addonpayments.com/pay')
          RealexHpp.embedded.init(
              "autoload",
              "targetIframe",
              `https://www.dtouch.es/assets/addon-payments/response.php?locale=${this.locale}`,
              body
          );
          /
          document.body.classList.add('loaded')
          this.payStep = true
        */
        } catch (error) {
          alert('Error')
          console.log(error)
        }
      },
      prepareTerms () {
        if(!this.terms) this.sTerms = null
        const aux = utils.getTranslation(this.terms, this.locale)
        this.sTerms = aux && aux.length > 0 ? aux : null
      },
      async handleConfirm () {
      // TODO: JHM
      if (this.$route.query.point && this.workspaceID) await apiDishOrders.preparePoint()

        this.showRequired = false
        this.showRequired = this.formConfirm.filter(x => (!x.value || x.value.length === 0) && x.name !== 'email').length > 0
        if (this.showRequired) return
      /*
        this.showRequired = !this.card.name || this.card.name.length === 0
                            || !this.card.number || this.card.number.length === 0
                            || !this.card.expiry_month || this.card.expiry_month.length === 0
                            || !this.card.expiry_year || this.card.expiry_year.length === 0
                            || !this.card.cvv || this.card.cvv.length === 0
                            
        if (this.showRequired) return
        */


      this.preparePay()
      /*

        const body = {
          email: this.email,
          formConfirm: this.formConfirm,
          isAcceptTerms: this.isAcceptTerms,
          card: this.card
        }
        this.onPay(body)
      */
      },
      handleChangeAcceptTerms () {
        this.isAcceptTerms = this.isAcceptTerms ? false : true
      },
    },
  }
</script>

